import React, { useRef, useEffect, useState } from 'react';
import styles from './CheckboxLabel.module.scss'
import { Checkbox } from '../index'
import { Image, Svg } from '../../index'
import {
  userImageUrls,
  themeColors,
} from '../../../constants'

import { evaluate } from 'mathjs'
import { round } from '../../../utilities/Calculator'
import { toSettlement } from '../../../utilities/currencyDisplay'

const OwerCheckboxLabel = ({
  exponent,
  fixedAmount,
  valid,
  children,
  amount,
  object,
  changed,
  inputChanged,
  checked,
  handleAddCoverCostUser,
  value,
  isForeign,
  displayRate,
  displayExponent,
  displayCode,
  bookSymbol,
  bookExponent
}) => {
  const [_amount, setAmount] = useState(amount)
  const [settle, setSettle] = useState(true)
  const [_valid, setValid] = useState(true)
  const inputRef = useRef(null)

  // When foreign, the row's `amount` is already in the SELECTED currency (the
  // editor is canonical there), so it's displayed/edited as-is using `exponent`
  // (the selected currency's). We only derive a settlement-currency reference
  // (≈ ¥…) for context; the settlement allocation itself is computed at submit.
  const settlementRef = (isForeign && displayRate)
    ? toSettlement(amount, { isForeign, rate: displayRate, bookExponent })
    : null

  useEffect(() => {
    if (fixedAmount) {
      if (amount > fixedAmount) {
        setValid(false)
      }
    } else {
      let [valid, _] = checkValid(amount)
      setValid(valid)
    }
  }, [amount])

  useEffect(() => {
    if (fixedAmount && value > fixedAmount) {
      setValid(false)
    }

    setAmount(amount)
  }, [value])

  const checkValid = (value, exp = exponent) => {
    let isValid = false

    if (value === '' || value === null) {
      isValid = true
      return [isValid, 0]
    }

    try {
      value = evaluate(value)
      if (value >= 0 ) {
        isValid = true
      } else {
        isValid = false
      }
    } catch {
      value = 0
      isValid = false
    }

    return [isValid, round(value, exp)]
  }

  useEffect(() => {
    if (settle) {
      setAmount(amount)
      let [valid, _] = checkValid(amount)
      setValid(valid)
    }
  }, [amount])

  const handleCheckboxChanged = (e) => {
    if (e.target.checked) {
    } else {
      setAmount('')
    }

    changed(e)
  }

  const handleInputChanged = (e) => {
    setSettle(false)

    // `value` is the amount in the editor's working currency (selected when
    // foreign, else the book's), rounded to `exponent` which is set to match.
    let [valid, value] = checkValid(e.target.value)

    setValid(valid)
    setAmount(e.target.value)
    inputChanged(e, object.id, value)
  }

  const handleKeyUp = (e) => {
    if (e.key === 'Enter') {
      handeInputBlur()
    }
  }

  let imageUrl = object.imageURL
  if (!imageUrl) {
    imageUrl = userImageUrls[object.imageId]
  }

  const handeInputBlur = () => {
    let value;

    try {
      value = evaluate(_amount)
      setValid(true)
    } catch {
      setValid(false)
      value = 0
    }

    if (fixedAmount) {
      if (value > fixedAmount) {
        setValid(false)
      }
    }

    if (value < 0) {
      value = 0
    }

    value = round(value, exponent)

    setAmount(value)
    inputChanged(null, object.id, value)
    setSettle(true)
  }

  const handleEditClicked = () => {
    setAmount('')
    inputRef.current.focus()
  }

  return (
    <div className={[styles.label, styles.owerLabel].join(' ')}>
      <label style={{ display: 'flex', alignItems: 'center', paddingLeft: '20px' }}>
        <Checkbox
          style={{ paddingRight: '12px' }}
          value={value}
          changed={handleCheckboxChanged}
          checked={checked}
        />
        <Image style={{ paddingRight: '12px' }} imageUrl={imageUrl} defaultImage='user'/>
      </label>
      <div className={styles.flexCenter}>
        <div className={styles.flexColumn}>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'baseline' }}>
            <div className={styles.displayName} style={{ minWidth: 0 }}>
              {object.displayName}
            </div>
            {
              isForeign && parseFloat(amount) > 0 && settlementRef != null
                ? <span style={{ flexShrink: 0, marginLeft: '8px', fontSize: '12px', color: themeColors.gray600, whiteSpace: 'nowrap' }}>
                    ≈ {bookSymbol}{settlementRef}
                  </span>
                : null
            }
          </div>
          <div className={[styles.inputWrapper, _valid ? '' : styles.inputInValid].join(' ')}>
            <input
              ref={inputRef}
              onBlur={handeInputBlur}
              className={styles.input}
              type="text"
              placeholder="輸入算式或金額"
              onFocus={() => { setAmount('') }}
              value={_amount || ''}
              onKeyPress={handleKeyUp}
              onChange={handleInputChanged}/>
            {
              isForeign && displayCode
                ? <span style={{ marginBottom: '1px', fontSize: '13px', fontWeight: 600, color: _valid ? themeColors.gold900 : themeColors.redText, whiteSpace: 'nowrap' }}>{displayCode}</span>
                : <Svg
                    clicked={handleEditClicked}
                    className={_valid ? 'gray700' : 'invalid'}
                    style={{
                      marginBottom: '1px',
                      fontSize: '16px'
                    }}
                    icon='amount'
                    size='24'/>
            }
          </div>
        </div>
      </div>
    </div>
  )
};

const _styles = {
  icon: {
    width: '18px',
    height: '18px',
    display: 'flex',
    justifyContent: 'center',
  }
}

export default OwerCheckboxLabel
